/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const alertsState = {
    open: false,
    message: undefined,
};
